export default "__VITE_ASSET__81cb80d4__"